import React from "react";
import talking_image from "../images/drinking-wine-pana.svg"
import "./Blog.css";

const Blog = () => {
  return (
    <div className="blog-container">
      <div className="blog-content">
        <img
          src={talking_image}
          alt="Blog"
          className="blog-image"
        />
        <div className="blog-unavailable">Oops! This page is still in the workshop! 🛠️</div>
        <p className="blog-message">
        Check back someday for my blog! Exciting reads are on the horizon! 🚀
        </p>
      </div>
    </div>
  );
};

export default Blog;